import { render, staticRenderFns } from "./iconPopover.vue?vue&type=template&id=120e9b06&scoped=true&"
import script from "./iconPopover.vue?vue&type=script&lang=js&"
export * from "./iconPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e9b06",
  null
  
)

export default component.exports